<script>
	import Highnav from "./components/highnav.svelte";
	import Contact from "./components/contact.svelte";
	import Home from "./components/home.svelte";
	
</script>

<main>
	<Highnav/>
	<Home/>
	<Contact/>

</main>

<style>
main{
	width: 100vw;
	max-width: 100vw;
	min-height: 100vh;
	height: 100vh;
	padding-top: 10vh;
	overflow: hidden;
	background: #141615;
}
</style>